import React, { useState, useEffect, useMemo, useRef } from "react";
import Header from "../../../components/UserNavbar/UserNavbar";
import Footer from "../../../components/UserFooter/UserFooter";
import {
    Container,
    Box,
    Typography,
    Button,
    Checkbox,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    TablePagination,
    TextField,
    CircularProgress,
    Card,
    CardContent,
    Fade,
    IconButton,
} from "@mui/material";
import {
    CheckCircle as CheckCircleIcon,
    LocalOffer as CouponIcon,
    AccountBalanceWallet as PointsIcon,
    Close as CloseIcon,
    Celebration as CelebrationIcon,
} from "@mui/icons-material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { userCoupons, applyCoupon, MAIN_URL, deleteUserAccount, updateUserToggle, markCouponOpened, updateUserByMobile } from "../../../api/api";
import Cookies from "js-cookie";
import { redeemPoints } from "../../../api/api";
import { useLocation } from "react-router-dom";
import { getCouponImageStyles, getCouponContainerStyles } from "../../../constants/imageSizes";

let swalLoaderPromise;
const getSwal = async () => {
    if (!swalLoaderPromise) {
        swalLoaderPromise = import("sweetalert2").then((module) => module.default);
    }
    return swalLoaderPromise;
};

const Index = () => {
    const [value, setValue] = useState("1");
    const [coupons, setCoupons] = useState([]);
    const [userId, setUserId] = useState("");
    const [userDetails, setUserDetails] = useState({});
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [emailLoading, setEmailLoading] = useState(false);
    const [pointsToUse, setPointsToUse] = useState("");
    const [loading, setLoading] = useState(false);
    const [valueBankDetails, setValueBankDetails] = useState([]);
    const [deleteAccountChecked, setDeleteAccountChecked] = useState(false);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [infoToggleLoading, setInfoToggleLoading] = useState(false);
    const [alertModalOpen, setAlertModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [useCouponLoading, setUseCouponLoading] = useState(false);
    const [welcomeModalOpen, setWelcomeModalOpen] = useState(false);
    const [fetchError, setFetchError] = useState(null); // Add error state
    const [shouldLoadAdIframe, setShouldLoadAdIframe] = useState(false);
    const iframeContainerRef = useRef(null);
    // Removed clickedChristmasCoupons state - now using database "opened" status
    


    const showSwal = async (options) => {
        const Swal = await getSwal();
        return Swal.fire(options);
    };

    useEffect(() => {
        if (!shouldLoadAdIframe) return;

        const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
        
        const isLandscape = () => {
            return window.innerWidth > window.innerHeight;
        };

        const updateIframeDimensions = () => {
            const iframe = document.getElementById("content-iframe");
            if (!iframe) return;

            const container = iframe.parentElement;
            if (!container) return;

            const containerWidth = container.clientWidth;
            const isLandscapeMode = isLandscape();
            
            // Set width dynamically based on container
            iframe.style.width = "100%";
            
            // For landscape view, use more sophisticated height calculation
            if (isLandscapeMode) {
                // In landscape, use viewport height or container-based calculation
                const viewportHeight = window.innerHeight;
                const maxHeight = Math.min(viewportHeight * 0.6, containerWidth * 0.4); // Maintain aspect ratio
                iframe.style.height = `${maxHeight}px`;
            } else {
                // Portrait mode - use viewport height percentage
                if (isMobile()) {
                    iframe.style.height = "60vh";
                } else {
                    // Desktop portrait - use a reasonable height
                    iframe.style.height = "50vh";
                }
            }
        };

        const handleMessage = (event) => {
            if (event.origin !== "https://admin.easyque.eu") return;

            const iframe = document.getElementById("content-iframe");
            if (!iframe) return;

            // Handle height from iframe content
            if (event.data.height) {
                const isLandscapeMode = isLandscape();
                const container = iframe.parentElement;
                const containerWidth = container ? container.clientWidth : window.innerWidth;
                
                if (isMobile() && !isLandscapeMode) {
                    // Mobile portrait - use viewport height
                    iframe.style.height = "60vh";
                } else if (isLandscapeMode) {
                    // Landscape mode - use dynamic calculation
                    const receivedHeight = parseInt(event.data.height);
                    const maxHeight = Math.min(receivedHeight, containerWidth * 0.5);
                    iframe.style.height = `${maxHeight}px`;
                } else {
                    // Desktop portrait - use received height but cap it
                    const receivedHeight = parseInt(event.data.height);
                    const maxHeight = Math.min(receivedHeight, window.innerHeight * 0.6);
                    iframe.style.height = `${maxHeight}px`;
                }
            }

            // Handle width if provided
            if (event.data.width) {
                const container = iframe.parentElement;
                if (container) {
                    const containerWidth = container.clientWidth;
                    const requestedWidth = parseInt(event.data.width);
                    // Use requested width but don't exceed container
                    iframe.style.width = `${Math.min(requestedWidth, containerWidth)}px`;
                }
            }
        };

        const setIframeSrc = () => {
            const iframe = document.getElementById("content-iframe");
            if (iframe) {
                const landscapeMode = isLandscape();
                iframe.src = (isMobile() && !landscapeMode)
                    ? "https://admin.easyque.eu/home/display_ad_Carousel_Portrait?branch_id=1"
                    : "https://admin.easyque.eu/home/display_ad_Carousel_landscape?branch_id=1";
                
                // Update dimensions after setting src
                setTimeout(updateIframeDimensions, 100);
            }
        };

        // Handle orientation and resize changes
        const handleResize = () => {
            const iframe = document.getElementById("content-iframe");
            if (iframe) {
                // Update iframe source if orientation changed
                const landscapeMode = isLandscape();
                const currentSrc = iframe.src;
                const shouldBeLandscape = currentSrc.includes("landscape");
                
                if (landscapeMode !== shouldBeLandscape) {
                    setIframeSrc();
                } else {
                    updateIframeDimensions();
                }
            }
        };

        const handleOrientationChange = () => {
            setTimeout(handleResize, 100);
        };

        window.addEventListener("message", handleMessage);
        window.addEventListener("load", setIframeSrc);
        window.addEventListener("resize", handleResize);
        window.addEventListener("orientationchange", handleOrientationChange);

        // Initial setup
        setIframeSrc();

        // Cleanup on unmount
        return () => {
            window.removeEventListener("message", handleMessage);
            window.removeEventListener("load", setIframeSrc);
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleOrientationChange);
        };
    }, [shouldLoadAdIframe]);

    useEffect(() => {
        const target = iframeContainerRef.current;
        if (!target) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0]?.isIntersecting) {
                    setShouldLoadAdIframe(true);
                    observer.disconnect();
                }
            },
            { rootMargin: "200px 0px" }
        );

        observer.observe(target);
        return () => observer.disconnect();
    }, []);



    // Pagination state for Verdibank table
    const [verdibankPage, setVerdibankPage] = useState(0);
    const [verdibankRowsPerPage, setVerdibankRowsPerPage] = useState(5);

    const { state } = useLocation();
    const company_id = state?.company_id;
    const mobile_from_state = state?.mobile;
    
    // Initialize currentCompanyId with cookie value or state value
    const [currentCompanyId, setCurrentCompanyId] = useState(() => {
        const cookieCompanyId = Cookies.get("company_id");
        return company_id || cookieCompanyId || null;
    });

    //console.log("Company ID:", company_id);
    const handleCouponClick = (coupon) => {
        setSelectedCoupon(coupon);
        setModalOpen(true);
    };

    const handleAddEmail = async () => {
        if (!email.trim()) {
            showAlert("Vennligst skriv inn en gyldig e-postadresse");
            return;
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showAlert("Vennligst skriv inn en gyldig e-postadresse");
            return;
        }

        setEmailLoading(true);
        try {
            const userId = Cookies.get("user_id");
            await updateUserByMobile(userDetails.mobile_number, { 
                email: email.trim(),
                company_id: currentCompanyId || Cookies.get("company_id"),
                user_id: userId // Include user_id for authorization
            });
            
            // Update local state
            setUserDetails(prev => ({ ...prev, email: email.trim() }));
            
            // Close modal and reset email
            setEmailModalOpen(false);
            setEmail("");
            
            showAlert("E-post oppdatert!");
        } catch (error) {
            console.error("Error updating email:", error);
            showAlert("Kunne ikke oppdatere e-post. Prøv igjen.");
        } finally {
            setEmailLoading(false);
        }
    };

    // Helper function to show alert modal
    const showAlert = (message) => {
        setAlertMessage(message);
        setAlertModalOpen(true);
    };

    // Helper function to sort dynamic coupons by open date priority
    const sortDynamicCoupons = (coupons) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
        
        return coupons.sort((a, b) => {
            // If no open_date, treat as regular coupon (lower priority)
            if (!a.open_date && !b.open_date) return 0;
            if (!a.open_date) return 1;
            if (!b.open_date) return -1;
            
            const aOpenDate = new Date(a.open_date);
            const bOpenDate = new Date(b.open_date);
            aOpenDate.setHours(0, 0, 0, 0);
            bOpenDate.setHours(0, 0, 0, 0);
            
            // Today's coupons first
            const aIsToday = aOpenDate.getTime() === today.getTime();
            const bIsToday = bOpenDate.getTime() === today.getTime();
            
            if (aIsToday && !bIsToday) return -1;
            if (!aIsToday && bIsToday) return 1;
            
            // If both are today or both are not today, sort by open date
            if (aIsToday && bIsToday) return 0;
            
            // Past dates (can be opened) come before future dates
            const aIsPast = aOpenDate < today;
            const bIsPast = bOpenDate < today;
            
            if (aIsPast && !bIsPast) return -1;
            if (!aIsPast && bIsPast) return 1;
            
            // Within same category (past/past or future/future), sort by open date
            return aOpenDate - bOpenDate;
        });
    };

    // Helper function to check dynamic campaign coupon time restrictions
    const checkDynamicCouponTiming = (coupon) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // Check open_date - coupon can only be opened after this date
        if (coupon.open_date) {
            const openDate = new Date(coupon.open_date);
            openDate.setHours(0, 0, 0, 0);
            
            if (today < openDate) {
                const daysUntilOpen = Math.ceil((openDate - today) / (1000 * 60 * 60 * 24));
                return { 
                    canOpen: false, 
                    canUse: false,
                    isExpired: false,
                    message: `${daysUntilOpen} dag${daysUntilOpen > 1 ? 'er' : ''} til du kan åpne denne kupongen` 
                };
            }
        }
        
        // Check usable_date and valid_days - coupon can be used from usable_date onwards
        // and is valid for valid_days (inclusive of usable_date)
        // Example: usable_date = Nov 16, valid_days = 2 means valid until Nov 17 (inclusive)
        if (coupon.usable_date) {
            const usableDate = new Date(coupon.usable_date);
            usableDate.setHours(0, 0, 0, 0);
            const validDays = coupon.valid_days || 0;
            // Calculate last valid day: usable_date + (valid_days - 1)
            // Example: Nov 16 + (2 - 1) = Nov 17 (last valid day)
            const expiryDate = new Date(usableDate);
            expiryDate.setDate(usableDate.getDate() + validDays - 1);
            
            // Check if coupon has expired (today is after the last valid day)
            if (today > expiryDate) {
                return { 
                    canOpen: true, 
                    canUse: false,
                    isExpired: true,
                    message: "Denne kupongen har utløpt og kan ikke lenger brukes." 
                };
            }
            
            // Check if coupon can be used yet (usable_date has not arrived)
            if (today < usableDate) {
                const daysUntilUsable = Math.ceil((usableDate - today) / (1000 * 60 * 60 * 24));
                return { 
                    canOpen: true, 
                    canUse: false,
                    isExpired: false,
                    message: `Denne kupongen kan brukes om ${daysUntilUsable} dag${daysUntilUsable > 1 ? 'er' : ''}` 
                };
            }
            
            // Coupon can be opened and used
            return { 
                canOpen: true, 
                canUse: true,
                isExpired: false,
                message: null 
            };
        }
        
        // If no usable_date, use old logic with open_date + valid_days
        // valid_days is inclusive of open_date
        if (coupon.open_date) {
            const openDate = new Date(coupon.open_date);
            openDate.setHours(0, 0, 0, 0);
            const validDays = coupon.valid_days || 0;
            // Last valid day = open_date + (valid_days - 1)
            const expiryDate = new Date(openDate);
            expiryDate.setDate(openDate.getDate() + validDays - 1);
            
            // Check if coupon has expired (today is after last valid day)
            if (today > expiryDate) {
                return { 
                    canOpen: true, 
                    canUse: false,
                    isExpired: true,
                    message: "Denne kupongen har utløpt og kan ikke lenger brukes." 
                };
            }
            
            // Check if coupon is still valid after opening
            if (coupon.opened === 1 || coupon.opened === "1") {
                const openedDate = new Date(coupon.opened_at || coupon.updated_at);
                openedDate.setHours(0, 0, 0, 0);
                const daysSinceOpened = Math.floor((today - openedDate) / (1000 * 60 * 60 * 24));
                
                // valid_days is inclusive, so if daysSinceOpened >= validDays, it's expired
                // Example: opened on Nov 16, valid_days = 2, so valid until Nov 17
                // On Nov 17: daysSinceOpened = 1, still valid
                // On Nov 18: daysSinceOpened = 2, expired
                if (daysSinceOpened >= validDays) {
                    return { 
                        canOpen: true, 
                        canUse: false,
                        isExpired: true,
                        message: "Denne kupongen har utløpt etter åpning og kan ikke lenger brukes." 
                    };
                }
            }
        }
        
        return { canOpen: true, canUse: true, isExpired: false, message: null };
    };

    const handleDynamicCampaignCouponClick = async (coupon) => {
        // Check dynamic campaign coupon timing restrictions
        const timingCheck = checkDynamicCouponTiming(coupon);
        
        if (!timingCheck.canOpen) {
            showAlert(timingCheck.message);
            return;
        }
        
        // If coupon is expired, show message
        if (timingCheck.isExpired) {
            showAlert(timingCheck.message);
            return;
        }
        
        // If coupon cannot be used yet (usable_date not reached), show message
        if (!timingCheck.canUse && timingCheck.message) {
            showAlert(timingCheck.message);
            return;
        }
        
        // For dynamic campaign coupons: 
        // First click: Switch between coupon_image_url and offer_image_url
        // Second click: Open modal for coupon usage
        if (coupon.opened === 1 || coupon.opened === "1") {
            // Already opened (image switched), open modal
            setSelectedCoupon(coupon);
            setModalOpen(true);
        } else {
            // First click, mark as opened in database and switch the image
            try {
                await markCouponOpened(coupon.id);
                // Update the local coupon state to reflect the change
                setCoupons(prevCoupons => 
                    prevCoupons.map(c => 
                        c.id === coupon.id ? { ...c, opened: 1, opened_at: new Date().toISOString() } : c
                    )
                );
            } catch (error) {
                console.error('Error marking coupon as opened:', error);
                // Still allow the image to switch even if API call fails
                setCoupons(prevCoupons => 
                    prevCoupons.map(c => 
                        c.id === coupon.id ? { ...c, opened: 1, opened_at: new Date().toISOString() } : c
                    )
                );
            }
        }
    };

    // Helper function to determine if coupon is from dynamic campaign
    const isDynamicCampaignCoupon = (coupon) => {
        // Check if campaign_type is 'dynamic'
        return coupon.campaign_type === 'dynamic';
    };

    // Helper function to determine if coupon should show offer image initially
    const shouldShowOfferImageInitially = (coupon) => {
        // Special campaigns that show offer image initially
        return coupon.campaign_name === 'julekalender2025';
    };

    // Helper function to get the appropriate image for display
    const getCouponImage = (coupon) => {
        if (isDynamicCampaignCoupon(coupon)) {
            // For dynamic campaigns: 
            // Some campaigns show offer image initially, others show coupon image
            if (shouldShowOfferImageInitially(coupon)) {
                // Show coupon image initially, offer image after opened
                if (coupon.opened === 1 || coupon.opened === "1") {
                    return coupon.offer_image_url ? `${MAIN_URL}/images/${coupon.offer_image_url}` : `${MAIN_URL}/images/k${coupon.coupon_initial_id}.webp`;
                } else {
                    return coupon.coupon_image_url ? `${MAIN_URL}/images/${coupon.coupon_image_url}` : `${MAIN_URL}/images/k${coupon.coupon_initial_id}.webp`;
                }
            } else {
                // Show coupon image initially, offer image after opened
                if (coupon.opened === 1 || coupon.opened === "1") {
                    return coupon.offer_image_url ? `${MAIN_URL}/images/${coupon.offer_image_url}` : `${MAIN_URL}/images/k${coupon.coupon_initial_id}.webp`;
                } else {
                    return coupon.coupon_image_url ? `${MAIN_URL}/images/${coupon.coupon_image_url}` : `${MAIN_URL}/images/k${coupon.coupon_initial_id}.webp`;
                }
            }
        } else {
            // Regular campaigns always show coupon image
            return coupon.coupon_image_url ? `${MAIN_URL}/images/${coupon.coupon_image_url}` : `${MAIN_URL}/images/k${coupon.coupon_initial_id}.webp`;
        }
    };

    // Memoize dynamic campaign names to avoid rebuilding list on each render.
    const dynamicCampaigns = useMemo(() => {
        return coupons
            .filter(coupon => coupon.campaign_type === 'dynamic')
            .map(coupon => coupon.campaign_name)
            .filter((value, index, self) => self.indexOf(value) === index); // Unique values
    }, [coupons]);

    const getCouponEndDate = (coupon) => {
        if (coupon.end_date) {
            const endDate = new Date(coupon.end_date);
            endDate.setHours(0, 0, 0, 0);
            return endDate;
        }
        if (coupon.usable_date) {
            const usableDate = new Date(coupon.usable_date);
            usableDate.setHours(0, 0, 0, 0);
            const validDays = coupon.valid_days || 0;
            if (validDays > 0) {
                const expiryDate = new Date(usableDate);
                expiryDate.setDate(usableDate.getDate() + validDays - 1);
                return expiryDate;
            }
            return usableDate;
        }
        if (coupon.open_date) {
            const openDate = new Date(coupon.open_date);
            openDate.setHours(0, 0, 0, 0);
            const validDays = coupon.valid_days || 0;
            if (validDays > 0) {
                const expiryDate = new Date(openDate);
                expiryDate.setDate(openDate.getDate() + validDays - 1);
                return expiryDate;
            }
            return openDate;
        }
        return new Date("9999-12-31");
    };

    const isCouponUsableToday = (coupon, today) => {
        if (coupon.usable_date) {
            const usableDate = new Date(coupon.usable_date);
            usableDate.setHours(0, 0, 0, 0);
            const validDays = coupon.valid_days || 0;
            if (validDays > 0) {
                const expiryDate = new Date(usableDate);
                expiryDate.setDate(usableDate.getDate() + validDays - 1);
                return today >= usableDate && today <= expiryDate;
            }
            return today >= usableDate;
        }
        if (coupon.open_date) {
            const openDate = new Date(coupon.open_date);
            openDate.setHours(0, 0, 0, 0);
            const validDays = coupon.valid_days || 0;
            if (validDays > 0) {
                const expiryDate = new Date(openDate);
                expiryDate.setDate(openDate.getDate() + validDays - 1);
                return today >= openDate && today <= expiryDate;
            }
            return today >= openDate;
        }
        return false;
    };

    const validCoupons = useMemo(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return coupons
            .filter(
                (coupon) =>
                    coupon.campaign_type !== "dynamic" &&
                    (coupon.used === 0 || coupon.used === "0") &&
                    new Date(coupon.end_date) >= today
            )
            .sort((a, b) => new Date(a.end_date) - new Date(b.end_date));
    }, [coupons]);

    const usedCoupons = useMemo(() => {
        return coupons
            .filter((coupon) => coupon.used === 1 || coupon.used === "1")
            .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
    }, [coupons]);

    const expiredCoupons = useMemo(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return coupons
            .filter((coupon) => {
                if (coupon.used === 1 || coupon.used === "1") {
                    return false;
                }

                if (coupon.campaign_type === "dynamic" && coupon.usable_date) {
                    const usableDate = new Date(coupon.usable_date);
                    usableDate.setHours(0, 0, 0, 0);
                    const validDays = coupon.valid_days || 0;
                    const expiryDate = new Date(usableDate);
                    expiryDate.setDate(usableDate.getDate() + validDays - 1);
                    return today > expiryDate;
                }

                if (coupon.campaign_type === "dynamic" && coupon.open_date && !coupon.usable_date) {
                    const openDate = new Date(coupon.open_date);
                    openDate.setHours(0, 0, 0, 0);
                    const validDays = coupon.valid_days || 0;
                    const expiryDate = new Date(openDate);
                    expiryDate.setDate(openDate.getDate() + validDays - 1);
                    return today > expiryDate;
                }

                return new Date(coupon.end_date) < today;
            })
            .sort((a, b) => getCouponEndDate(b) - getCouponEndDate(a));
    }, [coupons]);

    const dynamicValidCouponsByCampaign = useMemo(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return dynamicCampaigns.reduce((acc, campaignName) => {
            const campaignCoupons = coupons
                .filter((coupon) => {
                    if (coupon.campaign_type !== "dynamic" || coupon.campaign_name !== campaignName) {
                        return false;
                    }
                    if (coupon.used === 1 || coupon.used === "1") {
                        return false;
                    }
                    if (coupon.open_date) {
                        const openDate = new Date(coupon.open_date);
                        openDate.setHours(0, 0, 0, 0);
                        if (today < openDate) {
                            return false;
                        }
                    }
                    return getCouponEndDate(coupon) >= today;
                })
                .sort((a, b) => {
                    const aUsableToday = isCouponUsableToday(a, today);
                    const bUsableToday = isCouponUsableToday(b, today);
                    if (aUsableToday && !bUsableToday) return -1;
                    if (!aUsableToday && bUsableToday) return 1;
                    return getCouponEndDate(a) - getCouponEndDate(b);
                });

            acc[campaignName] = campaignCoupons;
            return acc;
        }, {});
    }, [coupons, dynamicCampaigns]);

    const sortedValueBankDetails = useMemo(() => {
        return (Array.isArray(valueBankDetails) ? valueBankDetails : [])
            .slice()
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    }, [valueBankDetails]);

    const valueBankSummary = useMemo(() => {
        const items = Array.isArray(valueBankDetails) ? valueBankDetails : [];
        const earned = items
            .filter((item) => Number(item.points) > 0)
            .reduce((sum, item) => sum + Number(item.points), 0);
        const used = Math.abs(
            items
                .filter((item) => Number(item.points) < 0)
                .reduce((sum, item) => sum + Number(item.points), 0)
        );
        const balance = items.reduce((sum, item) => sum + Number(item.points), 0);
        return { earned, used, balance };
    }, [valueBankDetails]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleDeleteAccountCheck = (event) => {
        if (event.target.checked) {
            setDeleteConfirmationOpen(true);
        }
        setDeleteAccountChecked(event.target.checked);
    };

    const handleDeleteConfirmation = async () => {
        setDeleteLoading(true);
        try {
            const result = await deleteUserAccount(userId, currentCompanyId, true);
            if (result.status) {
                //alert("Din konto har blitt slettet. Du vil bli logget ut.");
                await showSwal({
                    title: 'Success',
                    text: 'Din konto har blitt slettet. Du vil bli logget ut.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                // Clear cookies and redirect to login
                Cookies.remove("user_id");
                Cookies.remove("company_id");
                window.location.href = "/";
            } else {
                //alert("Feil ved sletting av konto: " + result.message);
                await showSwal({
                    title: 'Error',
                    text: 'Feil ved sletting av konto: ' + result.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                setDeleteAccountChecked(false);
            }
        } catch (error) {
            console.error("Error deleting account:", error);
            //alert("En feil oppstod ved sletting av konto. Prøv igjen.");
            await showSwal({
                title: 'Error',
                text: 'En feil oppstod ved sletting av konto. Prøv igjen.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            setDeleteAccountChecked(false);
        } finally {
            setDeleteLoading(false);
            setDeleteConfirmationOpen(false);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteConfirmationOpen(false);
        setDeleteAccountChecked(false);
    };

    const handleInfoToggleChange = async (event) => {
        const isChecked = event.target.checked;
        const newValue = isChecked ? 0 : 1; // 0 means "don't want info", 1 means "want info"
        
      //  console.log("Info toggle change:", { isChecked, newValue, currentValue: userDetails.info_toggle });
        
        setInfoToggleLoading(true);
        try {
            const mobileNumber = userDetails.mobile_number || userDetails.mobile_no || userDetails.mobile_nr || mobile_from_state;
            if (!mobileNumber) {
                //alert("Mobile number not found. Please try again.");
                await showSwal({
                    title: 'Error',
                    text: 'Mobile number not found. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                setInfoToggleLoading(false);
                return;
            }

          //  console.log("Updating info toggle:", { mobileNumber, field: 'info_toggle', value: newValue });
            
            const result = await updateUserToggle(mobileNumber, 'info_toggle', newValue);
           // console.log("API response:", result);
            
            // Check for success in different possible response formats
            if (result.data && (
                result.data.success || 
                result.data.message === "Toggle updated successfully." || 
                result.data.message === "Toggle updated successfully" ||
                result.status === 200 ||
                result.statusText === "OK"
            )) {
                // Update the user details in state
                setUserDetails(prev => ({
                    ...prev,
                    info_toggle: newValue
                }));
                
                // Refresh user data to ensure we have the latest from database
                handleGetUserCoupons(userDetails.id, currentCompanyId);
                
                //alert("Preference updated successfully!");
                await showSwal({
                    title: 'Success',
                    text: 'Preference updated successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            } else {
                console.error("API returned error:", result.data);
              //  alert("Failed to update preference: " + (result.data?.message || "Unknown error"));
              await showSwal({
                title: 'Error',
                text: 'Failed to update preference: ' + (result.data?.message || "Unknown error"),
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
        } catch (error) {
            console.error("Error updating info toggle:", error);
            console.error("Error details:", error.response?.data);
            //alert("Error updating preference. Please try again.");
            await showSwal({
                title: 'Error',
                text: 'Error updating preference. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setInfoToggleLoading(false);
        }
    };

    // Function to translate descriptions to Norwegian for user interface
    const translateDescription = (description) => {
        const translations = {
            'Admin added points': 'Administrator la til poeng',
            'User redeemed points': 'Brukerinnløste poeng',
            'Admin deducted points': 'Administrator trakk fra poeng',
            'Brukerinnløste poeng': 'Brukerinnløste poeng', // Already Norwegian
            'Administrator la til poeng': 'Administrator la til poeng', // Already Norwegian
            'Administrator trakk fra poeng': 'Administrator trakk fra poeng' // Already Norwegian
        };
        
        return translations[description] || description;
    };

    // Pagination handlers for Verdibank table
    const handleVerdibankChangePage = (event, newPage) => {
        setVerdibankPage(newPage);
    };

    const handleVerdibankChangeRowsPerPage = (event) => {
        setVerdibankRowsPerPage(parseInt(event.target.value, 10));
        setVerdibankPage(0);
    };

    // Helper function to check toggle status
    const isToggleActive = (value) => {
        // Normalize toggle values from API/DB to avoid string-format inconsistencies.
        if (value === true || value === 1) return true;
        if (typeof value === "string") {
            const normalized = value.trim().toLowerCase();
            return normalized === "1" || normalized === "true";
        }
        return false;
    };

    // Handle tab visibility and default selection
    useEffect(() => {
        // Skip if userDetails are not loaded yet
        // Check if both are falsy (0, false, null, undefined, "")
        if (!isToggleActive(userDetails?.valuebank_toggle) && !isToggleActive(userDetails?.coupon_toggle)) {
            return;
        }
        
        // Get dynamic campaigns to check if they exist
        const hasDynamicCampaigns = dynamicCampaigns.length > 0;
        
        // Check if current value is a valid dynamic campaign tab
        const isValidDynamicTab = value && value.startsWith("dynamic_") && 
            dynamicCampaigns.some(campaign => value === `dynamic_${campaign}_valid`);
        
        // Priority: If dynamic campaigns exist, show first dynamic campaign tab
        // Otherwise, show appropriate default tab based on toggles
        if (isToggleActive(userDetails?.coupon_toggle) && hasDynamicCampaigns) {
            // If coupons are enabled and dynamic campaigns exist, prioritize first dynamic campaign tab
            const firstDynamicTab = `dynamic_${dynamicCampaigns[0]}_valid`;
            // Only set if not already on a valid dynamic tab
            if (!isValidDynamicTab) {
                setValue(firstDynamicTab);
            }
        } else if (isToggleActive(userDetails?.valuebank_toggle) && isToggleActive(userDetails?.coupon_toggle)) {
            // Both toggles are on, but no dynamic campaigns - default to VERDIBANK
            if (value !== "1" && value !== "2" && value !== "3" && value !== "4") {
                setValue("1");
            }
        } else if (isToggleActive(userDetails?.valuebank_toggle) && !isToggleActive(userDetails?.coupon_toggle)) {
            // Only valuebank is on
            setValue("1");
        } else if (!isToggleActive(userDetails?.valuebank_toggle) && isToggleActive(userDetails?.coupon_toggle)) {
            // Only coupons are on, but no dynamic campaigns - default to GYLDIGE (valid coupons)
            if (value !== "2" && value !== "3" && value !== "4") {
                setValue("2");
            }
        } else {
            // Neither toggle is on
            setValue("1");
        }
    }, [userDetails?.valuebank_toggle, userDetails?.coupon_toggle, dynamicCampaigns, value]);
    // Update currentCompanyId when company_id from state changes
    useEffect(() => {
        if (company_id) {
            setCurrentCompanyId(company_id);
        }
    }, [company_id]);

    useEffect(() => {
        const userId = Cookies.get("user_id");
        const companyId = Cookies.get("company_id");
        
        
        // Use company_id from state (from navigation) or fallback to cookie
        const resolvedCompanyId = company_id || companyId;
        console.log("- resolvedCompanyId:", resolvedCompanyId);
        
        setCurrentCompanyId(resolvedCompanyId);

        if (userId && resolvedCompanyId) {
            handleGetUserCoupons(userId, resolvedCompanyId);
            setUserId(userId);
        } else if (userId && !resolvedCompanyId) {
            console.warn("User logged in but no company ID found. Redirecting to company selection.");
            // Could redirect to company selection page here
        } else {
            console.warn("No user_id cookie found. User might be logged out.");
            // Optionally redirect or show a login warning here
        }
    }, [company_id]); // Add company_id to dependency array

    // Handle campaign messages from navigation state
    useEffect(() => {
        if (state?.message) {
            // Check if it's a welcome message for first-time users
            const isWelcomeMessage = state.message.toLowerCase().includes('velkommen') || 
                                     state.message.toLowerCase().includes('welcome');
            
            if (isWelcomeMessage) {
                // Welcome modal disabled - users see homepage directly
                // setTimeout(() => {
                //     setWelcomeModalOpen(true);
                // }, 800);
            } else {
                // Show regular alert for other messages
                setTimeout(() => {
                    showAlert(state.message);
                }, 500);
            }
        }
    }, [state?.message]);

    const handleGetUserCoupons = async (id, company_id) => {
        if (!id || !company_id) {
            console.error("Missing user ID or company ID");
            setFetchError("User ID or Company ID missing");
            return;
        }
        
        try {
            console.log("Fetching coupons for user:", id, "company:", company_id);
            setFetchError(null); // Clear previous errors
            const response = await userCoupons(id, company_id);
           // console.log("API Response User:", response.data.user);
          //  console.log("Toggle values - valuebank:", response.data.user.valuebank_toggle, "coupon:", response.data.user.coupon_toggle);
            
            setCoupons(response.data.coupons);
            setUserDetails({
                ...response.data.user,
                valuebank_toggle: isToggleActive(response.data.user?.valuebank_toggle) ? 1 : 0,
                coupon_toggle: isToggleActive(response.data.user?.coupon_toggle) ? 1 : 0,
            });
            setValueBankDetails(response.data.valueBank);
         
        } catch (error) {
            console.error("Error fetching coupons:", error);
            const errorMessage = error.response?.data?.message || error.message || "Failed to load coupons";
            setFetchError(errorMessage);
            // Could show user-friendly error message here
        }
    };
    const handleUseCoupon = async (couponId) => {
        setUseCouponLoading(true);
        try {
            const currentUserId = Cookies.get("user_id") || userId || userDetails.id;
            if (!currentUserId) {
                showAlert("Bruker-ID ikke funnet. Vennligst logg inn på nytt.");
                setUseCouponLoading(false);
                return;
            }
            const res = await applyCoupon(couponId, currentUserId);
            
            // Update the used coupon in the state
            setCoupons((prev) =>
                prev.map((c) =>
                    c.id === couponId ? { ...c, used: 1, status: "used" } : c
                )
            );
            
            // Check if a new coupon was created (multiused coupon)
            if (res.data.new_coupon) {
                // Add the new coupon to the state
                setCoupons((prev) => [...prev, res.data.new_coupon]);
                
                // Show success message for multiused coupon
                showAlert("Kupong brukt! En ny kupong har blitt automatisk lagt til kontoen din.");
            } else {
                // Show regular success message
                showAlert("Kupong brukt!");
            }
            
            setModalOpen(false);
            
            // Refresh the coupons list to ensure we have the latest data
            handleGetUserCoupons(userDetails.id, currentCompanyId);
            
        } catch (error) {
            console.error("Error using coupon:", error.response?.data || error);
            showAlert(error.response?.data?.message || "Feil ved bruk av kupong. Prøv igjen.");
        } finally {
            setUseCouponLoading(false);
        }
    };
    const handleUsePoints = async () => {
        if (!pointsToUse || isNaN(pointsToUse) || pointsToUse <= 0) {
            showAlert("Vennligst skriv inn et gyldig antall poeng");
            return;
        }

        if (!currentCompanyId) {
            //alert("Company ID not found. Please try logging in again.");
            await showSwal({
                title: 'Error',
                text: 'Company ID not found. Please try logging in again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        setLoading(true);
        try {
            const res = await redeemPoints({
                user_id: userDetails.id,
                company_id: currentCompanyId,
                points: Number(pointsToUse),
            });

            if (res.data.success) {
            showAlert("Poeng innløst!");
                setPointsToUse(""); // Clear input
                handleGetUserCoupons(userDetails.id, currentCompanyId);
                // refreshBalance(); // Reload user balance from parent
            } else {
                //alert(res.data.error || "Something went wrong");
                await showSwal({
                    title: 'Error',
                    text: 'Something went wrong',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error(error);
            //alert(error.response?.data?.error || "Error redeeming points");
            await showSwal({
                title: 'Error',
                text: 'Error redeeming points',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false);
        }
    };
    //console.log("Passing to Header - currentCompanyId:", currentCompanyId);
    
    return (
        <>
            <Header company_id={currentCompanyId || Cookies.get("company_id")} />
            <Container sx={{ 
                maxWidth: { xs: "100%", sm: "600px", md: "800px", lg: "1200px" },
                px: { xs: 1, sm: 2 },
                py: { xs: 2, sm: 3 }
            }}>
                {/* User Information Section */}
                <Box mb={3}>
                    {/* Mobile Number Row */}
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        py: 1.5
                    }}>
                        <Typography sx={{ 
                            fontSize: { xs: "0.9rem", sm: "1rem" }, 
                            minWidth: { xs: '100px', sm: '120px' },
                            fontWeight: 500
                        }}>
                            Mobil/BrukerID:
                        </Typography>
                        <Typography sx={{ 
                            fontSize: { xs: "0.9rem", sm: "1rem" }, 
                            textAlign: 'center', 
                            flex: 1,
                            fontWeight: 400
                        }}>
                            {userDetails.mobile_number || userDetails.mobile_no || userDetails.mobile_nr || mobile_from_state || 'N/A'}
                        </Typography>
                    </Box>
                    <Divider />

                    {/* Email Row */}
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        py: 1.5
                    }}>
                        <Typography sx={{ 
                            fontSize: { xs: "0.9rem", sm: "1rem" }, 
                            minWidth: { xs: '100px', sm: '120px' },
                            fontWeight: 500
                        }}>
                            E-post:
                        </Typography>
                        <Box sx={{ flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                            {userDetails.email ? (
                                    <Typography sx={{ 
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                        fontWeight: 400
                                    }}>
                                        {userDetails.email}
                                    </Typography>
                            ) : (
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    size="small"
                                    onClick={() => setEmailModalOpen(true)}
                                    sx={{ minWidth: '120px' }}
                                >
                                    Legg til e-post
                                </Button>
                            )}
                        </Box>
                    </Box>
                    <Divider />
                    
                  
                </Box>

                {/* Email Modal */}
                <Modal open={emailModalOpen} onClose={() => setEmailModalOpen(false)}>
                    <Box sx={{ 
                        position: 'absolute', 
                        top: '50%', 
                        left: '50%', 
                        transform: 'translate(-50%, -50%)', 
                        width: { xs: '90%', sm: 400 }, 
                        bgcolor: 'background.paper', 
                        boxShadow: 24, 
                        p: 4, 
                        borderRadius: 2 
                    }}>
                        <Typography variant="h6" sx={{ mb: 3, textAlign: 'center' }}>
                            {userDetails.email ? "Rediger e-post" : "Legg til e-post"}
                        </Typography>
                        <TextField 
                            label="E-post" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            sx={{ mb: 3 }}
                            type="email"
                            placeholder="Skriv inn din e-postadresse"
                        />
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                            <Button 
                                variant="outlined" 
                                onClick={() => {
                                    setEmailModalOpen(false);
                                    setEmail("");
                                }}
                                disabled={emailLoading}
                                sx={{ minWidth: '80px' }}
                            >
                                Avbryt
                            </Button>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleAddEmail}
                                disabled={emailLoading}
                                sx={{ minWidth: '100px' }}
                            >
                                {emailLoading ? "Oppdaterer..." : (userDetails.email ? "Oppdater" : "Legg til")}
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                <Box>
                    <Typography variant="h6" sx={{ 
                        fontSize: { xs: "1rem", sm: "1.25rem" },
                        fontWeight: "bold",
                        mb: 1
                    }}>
                        Under finner du dine kuponger og saldo Verdibank{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ 
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                        mb: 1
                    }}>
                        Hver kupong kan kun brukes en gang og skal vises/trykkes
                        på sammen med de ansatte når de benyttes.{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ 
                        fontSize: { xs: "0.875rem", sm: "1rem" }
                    }}>
                        Verdibanken viser hva du har av saldo for fremtidig
                        bruk. Hvert poeng er lik kr. 1,-. Bruk av Verdibank gir
                        nye poeng på total etter fratrekk av poeng brukt.
                    </Typography>
                </Box>
                <Box sx={{ width: "100%", typography: "body1" }}>
                    {fetchError ? (
                         <Box sx={{ 
                            p: 3, 
                            textAlign: 'center',
                            backgroundColor: '#ffebee',
                            borderRadius: 2,
                            border: '1px solid #ef5350'
                        }}>
                            <Typography variant="h6" color="error" sx={{ mb: 1 }}>
                                Feil ved lasting av data
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {fetchError === "User not found" 
                                    ? "Bruker ble ikke funnet for dette selskapet. Vennligst sjekk at du er registrert." 
                                    : fetchError}
                            </Typography>
                        </Box>
                    ) : (isToggleActive(userDetails?.valuebank_toggle) || isToggleActive(userDetails?.coupon_toggle)) ? (
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <TabList
                                    onChange={handleChange}
                                    aria-label="lab API tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    sx={{
                                        '& .MuiTab-root': {
                                            minWidth: { xs: 'auto', sm: 'auto' },
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            padding: { xs: '6px 8px', sm: '12px 16px' }
                                        }
                                    }}
                                >
                                    {isToggleActive(userDetails?.valuebank_toggle) && (
                                        <Tab label="VERDIBANK" value="1" />
                                    )}
                                    {isToggleActive(userDetails?.coupon_toggle) && dynamicCampaigns.map((campaignName, idx) => (
                                        <Tab key={`${campaignName}_valid`} label={campaignName.toUpperCase()} value={`dynamic_${campaignName}_valid`} />
                                    ))}
                                    {isToggleActive(userDetails?.coupon_toggle) && [
                                        <Tab key="gyldige" label="GYLDIGE" value="2" />,
                                        <Tab key="brukte" label="BRUKTE" value="3" />,
                                        <Tab key="utlopte" label="UTLØPTE" value="4" />
                                    ]}
                                </TabList>
                            </Box>
                        {isToggleActive(userDetails?.valuebank_toggle) && (
                            <TabPanel value="1">
                                {/* <Box sx={{ mb: 2 }}>
                                    <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                                        VERDIBANK TRANSAKSJONER
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box sx={{ 
                                                width: 16, 
                                                height: 16, 
                                                backgroundColor: '#e8f5e8',
                                                border: '1px solid #2e7d32',
                                                borderRadius: 1
                                            }} />
                                            <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                                                Få poeng (positivt)
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box sx={{ 
                                                width: 16, 
                                                height: 16, 
                                                backgroundColor: '#ffeaea',
                                                border: '1px solid #d32f2f',
                                                borderRadius: 1
                                            }} />
                                            <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                                                Bruk poeng (negativt)
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box> */}
                                <Box
                                    sx={{
                                        px: { xs: 1.5, sm: 2 },
                                        py: 1.5,
                                        mb: 1.5,
                                        borderRadius: 1,
                                        border: "1px solid",
                                        borderColor: "divider",
                                        bgcolor: "grey.50",
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: { xs: "0.8rem", sm: "0.875rem" },
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        <Box component="span" sx={{ fontWeight: 700 }}>
                                            Din konto:
                                        </Box>{" "}
                                        Opptjent +{valueBankSummary.earned}
                                        {" · "}
                                        Brukte −{valueBankSummary.used}
                                        {" · "}
                                        <Box component="span" sx={{ fontWeight: 700 }}>
                                            Saldo {valueBankSummary.balance}
                                        </Box>
                                    </Typography>

                                    <Box sx={{ mt: 1.25 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: { xs: "0.8rem", sm: "0.875rem" },
                                                mb: 0.25,
                                            }}
                                        >
                                            OPPDATERING
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                                lineHeight: 1.45,
                                                color: "text.secondary",
                                            }}
                                        >
                                            Din Verdibank holdes løpende oppdatert, men det kan ta 48
                                            timer. Lurer du på noe så send en e-post til adressen under.
                                        </Typography>
                                    </Box>
                                </Box>

                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mb: 0.75 }}
                                >
                                    * Betingelser for bruk
                                </Typography>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", sm: "row" },
                                        alignItems: { sm: "center" },
                                        gap: 1,
                                        mb: 1,
                                    }}
                                >
                                    <TextField
                                        type="number"
                                        placeholder="Antall poeng du vil bruke"
                                        value={pointsToUse}
                                        onChange={(e) => setPointsToUse(e.target.value)}
                                        inputProps={{ min: 0, inputMode: "numeric" }}
                                        sx={{
                                            flex: 1,
                                            width: "100%",
                                            minWidth: { sm: 300 },
                                            maxWidth: { sm: 420 },
                                            "& .MuiInputBase-root": {
                                                height: 44,
                                            },
                                            "& .MuiInputBase-input": {
                                                fontSize: "16px",
                                                py: 1,
                                            },
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        onClick={handleUsePoints}
                                        disabled={loading}
                                        sx={{
                                            minWidth: { xs: "100%", sm: 100 },
                                            height: 44,
                                            flexShrink: 0,
                                        }}
                                    >
                                        {loading ? "Processing..." : "BRUK"}
                                    </Button>
                                </Box>

                                <Box>
                                    <TableContainer
                                        component={Paper}
                                        sx={{ 
                                            mt: 2,
                                            overflowX: 'auto',
                                            '&::-webkit-scrollbar': {
                                                height: '8px',
                                            },
                                            '&::-webkit-scrollbar-track': {
                                                backgroundColor: '#f1f1f1',
                                            },
                                            '&::-webkit-scrollbar-thumb': {
                                                backgroundColor: '#c1c1c1',
                                                borderRadius: '4px',
                                            },
                                        }}
                                    >
                                        <Table size="small" sx={{ minWidth: 300 }}>
                                            <TableHead>
                                                <TableRow
                                                    sx={{
                                                        background: "#e9ecef",
                                                    }}
                                                >
                                                    <TableCell>
                                                        <strong>Dato</strong>
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>Poeng</strong>
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>
                                                            Kommentar
                                                        </strong>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody
                                                sx={{ background: "#fafafa" }}
                                            >
                                                {sortedValueBankDetails
                                                    .slice(verdibankPage * verdibankRowsPerPage, verdibankPage * verdibankRowsPerPage + verdibankRowsPerPage)
                                                    .map(
                                                    (item) => (
                                                        <TableRow 
                                                            key={item.id}
                                                            sx={{
                                                                backgroundColor: Number(item.points) > 0 
                                                                    ? '#e8f5e8' // Light green for positive points (get points)
                                                                    : '#ffeaea' // Light red for negative points (redeem points)
                                                            }}
                                                        >
                                                            <TableCell>
                                                                {new Date(item.date).toLocaleDateString("no-NO", {
                                                                    day: "2-digit",
                                                                    month: "2-digit", 
                                                                    year: "2-digit"
                                                                })}
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography 
                                                                    sx={{ 
                                                                        color: Number(item.points) > 0 ? '#2e7d32' : '#d32f2f',
                                                                        fontWeight: 'medium'
                                                                    }}
                                                                >
                                                                    {Number(item.points) > 0 ? '+' : ''}{item.points}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    translateDescription(item.description)
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={valueBankDetails.length}
                                        rowsPerPage={verdibankRowsPerPage}
                                        page={verdibankPage}
                                        onPageChange={handleVerdibankChangePage}
                                        onRowsPerPageChange={handleVerdibankChangeRowsPerPage}
                                        labelRowsPerPage="Rader per side:"
                                        labelDisplayedRows={({ from, to, count }) => 
                                            `${from}-${to} av ${count !== -1 ? count : `mer enn ${to}`}`
                                        }
                                    />
                                </Box>

                                <Typography sx={{ 
                                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                    mt: 2,
                                    lineHeight: 1.3
                                }}>
                                    * POENGENE KAN KUN BENYTTES HOS FARGERIKE
                                    MAJORSTUEN OG KAN IKKE OVERFØRES TIL ANDRE.{" "}
                                    <br />
                                    BRUKEN AV POENG KAN KUN BENYTTES PÅ ORDINÆRE
                                    PRISER OG KAN IKKE KOMBINERES MED KAMPANJER
                                    ELLER ANDRE TILBUD. 1 POENG = 1 KR (INKL
                                    MVA).
                                </Typography>
                            </TabPanel>
                        )}
                        {isToggleActive(userDetails?.coupon_toggle) && (
                            <>
                                <TabPanel value="2">
                                    {validCoupons.length === 0 ? (
                                        <Box sx={{ textAlign: 'center', py: 4 }}>
                                            <Typography variant="h6" color="text.secondary">
                                                Ingen gyldige kuponger tilgjengelig
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                                Du har ingen aktive kuponger for øyeblikket.
                                            </Typography>
                                        </Box>
                                    ) : (
                                        validCoupons.map((coupon) => (
                                            <Box
                                                key={coupon.id}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    mb: 3,
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    "&:hover": {
                                                        transform: "scale(1.02)"
                                                    },
                                                }}
                                                onClick={() =>
                                                    isDynamicCampaignCoupon(coupon) 
                                                        ? handleDynamicCampaignCouponClick(coupon)
                                                        : handleCouponClick(coupon)
                                                }
                                            >
                                                <Box sx={{
                                                    position: "relative",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    ...getCouponContainerStyles('LARGE')
                                                }}>
                                                    <img
                                                        src={getCouponImage(coupon)}
                                                        alt={coupon.name}
                                                        loading="lazy"
                                                        decoding="async"
                                                        style={getCouponImageStyles('LARGE')}
                                                    />
                                                    {/* Multiused indicator */}
                                                    {coupon.multiused === 1 && (
                                                        <Box sx={{
                                                            position: 'absolute',
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor: '#4caf50',
                                                            color: 'white',
                                                            borderRadius: '50%',
                                                            width: 24,
                                                            height: 24,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                                        }}>
                                                            ∞
                                                        </Box>
                                                    )}
                                                    <Box sx={{
                                                        mt: 1,
                                                        textAlign: "center",
                                                        maxWidth: "300px"
                                                    }}>
                                                        <Typography fontWeight="bold" sx={{ 
                                                            fontSize: { xs: "0.8rem", sm: "0.8rem" },
                                                            mb: 0.5
                                                        }}>
                                                           GYLDIG TIL : {new Date(coupon.end_date).toLocaleDateString("no-NO", {
                                                               day: "2-digit",
                                                               month: "2-digit", 
                                                               year: "2-digit"
                                                           })}
                                                        </Typography>
                                                       
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))
                                    )}

                                    <Typography sx={{ 
                                        mt: 2,
                                        fontSize: { xs: "0.7rem", sm: "0.75rem" },
                                        lineHeight: 1.4
                                    }}>
                                        * DENNE FANEN VISER GYLDIGE KUPONGER SOM
                                        BRUKERE KAN LØSE IN TIL UTLØPSDATOEN.
                                    </Typography>
                                </TabPanel>

                                <TabPanel value="3">
                                    {usedCoupons.length === 0 ? (
                                        <Box sx={{ textAlign: 'center', py: 4 }}>
                                            <Typography variant="h6" color="text.secondary">
                                                Ingen brukte kuponger
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                                Du har ikke brukt noen kuponger ennå.
                                            </Typography>
                                        </Box>
                                    ) : (
                                        usedCoupons.map((coupon) => (
                                            <Box
                                                key={coupon.id}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    mb: 3,
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    "&:hover": {
                                                        transform: "scale(1.02)"
                                                    },
                                                }}
                                                onClick={() =>
                                                    handleCouponClick(coupon)
                                                }
                                            >
                                                <Box sx={{
                                                    position: "relative",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    ...getCouponContainerStyles('LARGE')
                                                }}>
                                                    <img
                                                        src={getCouponImage(coupon)}
                                                        alt={coupon.name}
                                                        loading="lazy"
                                                        decoding="async"
                                                        style={getCouponImageStyles('LARGE')}
                                                    />
                                                    {/* Multiused indicator */}
                                                    {coupon.multiused === 1 && (
                                                        <Box sx={{
                                                            position: 'absolute',
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor: '#4caf50',
                                                            color: 'white',
                                                            borderRadius: '50%',
                                                            width: 24,
                                                            height: 24,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                                        }}>
                                                            ∞
                                                        </Box>
                                                    )}
                                                    <Box sx={{
                                                        mt: 1,
                                                        textAlign: "center",
                                                        maxWidth: "300px"
                                                    }}>
                                                        <Typography fontWeight="bold" sx={{ 
                                                            fontSize: { xs: "0.8rem", sm: "0.8rem" },
                                                            mb: 0.5
                                                        }}>
                                                           BENYTTET : {new Date(coupon.updated_at).toLocaleDateString("no-NO", {
                                                               day: "2-digit",
                                                               month: "2-digit", 
                                                               year: "2-digit"
                                                           })}
                                                        </Typography>
                                                      
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))
                                    )}
                                    <Typography sx={{ 
                                        mt: 2,
                                        fontSize: { xs: "0.7rem", sm: "0.75rem" },
                                        lineHeight: 1.4
                                    }}>
                                        * DENNE KATEGORIEN VISER BRUKTE
                                        KUPONGER, SLIK AT BRUKERE KAN SE
                                        DETALJENE FOR TIDLIGERE INNLØSTE
                                        KUPONGER
                                    </Typography>
                                </TabPanel>

                                <TabPanel value="4">
                                    {expiredCoupons.length === 0 ? (
                                        <Box sx={{ textAlign: 'center', py: 4 }}>
                                            <Typography variant="h6" color="text.secondary">
                                                Ingen utløpte kuponger
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                                Du har ingen utløpte kuponger.
                                            </Typography>
                                        </Box>
                                    ) : (
                                        expiredCoupons.map((coupon) => (
                                            <Box
                                                key={coupon.id}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    mb: 3,
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out",
                                                    "&:hover": {
                                                        transform: "scale(1.02)"
                                                    },
                                                }}
                                                onClick={() =>
                                                    handleCouponClick(coupon)
                                                }
                                            >
                                                <Box sx={{
                                                    position: "relative",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    ...getCouponContainerStyles('LARGE')
                                                }}>
                                                    <img
                                                        src={getCouponImage(coupon)}
                                                        alt={coupon.name}
                                                        loading="lazy"
                                                        decoding="async"
                                                        style={getCouponImageStyles('LARGE')}
                                                    />
                                                    {/* Multiused indicator */}
                                                    {coupon.multiused === 1 && (
                                                        <Box sx={{
                                                            position: 'absolute',
                                                            top: 8,
                                                            right: 8,
                                                            backgroundColor: '#4caf50',
                                                            color: 'white',
                                                            borderRadius: '50%',
                                                            width: 24,
                                                            height: 24,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                                        }}>
                                                            ∞
                                                        </Box>
                                                    )}
                                                    <Box sx={{
                                                        mt: 1,
                                                        textAlign: "center",
                                                        maxWidth: "300px"
                                                    }}>
                                                        <Typography fontWeight="bold" sx={{ 
                                                            fontSize: { xs: "0.8rem", sm: "0.8rem" },
                                                            mb: 0.5
                                                        }}>
                                                            GYLDIG TIL : {new Date(coupon.end_date).toLocaleDateString("no-NO", {
                                                                day: "2-digit",
                                                                month: "2-digit", 
                                                                year: "2-digit"
                                                            })}
                                                        </Typography>
                                                        
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))
                                    )}
                                    <Typography sx={{ 
                                        mt: 2,
                                        fontSize: { xs: "0.7rem", sm: "0.75rem" },
                                        lineHeight: 1.4
                                    }}>
                                        * DENNE FANEN VISER UTLØPTE KUPONGER SOM
                                        IKKE BLE BRUKT AV BRUKEREN.
                                    </Typography>
                                </TabPanel>

                                {/* Dynamic Campaign Tabs - Only Valid Coupons */}
                                {dynamicCampaigns.map((campaignName) => (
                                    <TabPanel key={`dynamic_${campaignName}_valid`} value={`dynamic_${campaignName}_valid`}>
                                        {(dynamicValidCouponsByCampaign[campaignName] || []).length > 0 ? (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 2,
                                                        p: 2,
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {(dynamicValidCouponsByCampaign[campaignName] || []).map((coupon) => (
                                                        <Box
                                                            key={coupon.id}
                                                            sx={{
                                                                cursor: "pointer",
                                                                transition: "all 0.2s ease-in-out",
                                                                "&:hover": {
                                                                    transform: "scale(1.02)"
                                                                },
                                                            }}
                                                            onClick={() =>
                                                                isDynamicCampaignCoupon(coupon) 
                                                                    ? handleDynamicCampaignCouponClick(coupon)
                                                                    : handleCouponClick(coupon)
                                                            }
                                                        >
                                                            <Box sx={{
                                                                position: "relative",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                backgroundColor: "#fff",
                                                                borderRadius: 2,
                                                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                                overflow: "hidden",
                                                                ...getCouponContainerStyles('LARGE')
                                                            }}>
                                                                <img
                                                                    src={getCouponImage(coupon)}
                                                                    alt="Coupon"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    style={getCouponImageStyles('LARGE')}
                                                                />
                                                                
                                                                {/* Today's Open Date Badge */}
                                                                {/* {coupon.open_date && (() => {
                                                                    const today = new Date();
                                                                    const openDate = new Date(coupon.open_date);
                                                                    today.setHours(0, 0, 0, 0);
                                                                    openDate.setHours(0, 0, 0, 0);
                                                                    return today.getTime() === openDate.getTime();
                                                                })() && (
                                                                    <Box sx={{
                                                                        position: 'absolute',
                                                                        top: 8,
                                                                        left: 8,
                                                                        backgroundColor: '#ff6b35',
                                                                        color: 'white',
                                                                        px: 1.5,
                                                                        py: 0.5,
                                                                        borderRadius: 1,
                                                                        fontSize: '0.75rem',
                                                                        fontWeight: 'bold',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                                    }}>
                                                                        I DAG
                                                                    </Box>
                                                                )} */}
                                                                
                                                                {/* Valid Until Date */}
                                                               
                                                            </Box>
                                                            {coupon.end_date && (
                                                                    <Box sx={{
                                                                        mt: 1,
                                                                        textAlign: "center",
                                                                        maxWidth: "300px"
                                                                    }}>
                                                                        <Typography fontWeight="bold" sx={{ 
                                                                            fontSize: { xs: "0.8rem", sm: "0.8rem" },
                                                                            mb: 0.5
                                                                        }}>
                                                                            GYLDIG TIL : {new Date(coupon.end_date).toLocaleDateString("no-NO", {
                                                                                day: "2-digit",
                                                                                month: "2-digit", 
                                                                                year: "2-digit"
                                                                            })}
                                                                        </Typography>
                                                                     </Box>
                                                                )}
                                                        </Box>
                                                        
                                                    ))}
                                                </Box>
                                            ) : (
                                                <Typography variant="body1" sx={{ p: 3, textAlign: 'center' }}>
                                                    Ingen gyldige kuponger tilgjengelig for {campaignName}.
                                                </Typography>
                                            )}
                                    </TabPanel>
                                ))}
                            </>
                        )}
                    </TabContext>
                    ) : (
                        <Box sx={{ 
                            p: 3, 
                            textAlign: 'center',
                            backgroundColor: '#f5f5f5',
                            borderRadius: 2,
                            border: '1px solid #e0e0e0'
                        }}>
                            <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                                Ingen funksjoner tilgjengelig
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Verdibank og kuponger er for øyeblikket deaktivert for din konto.
                            </Typography>
                        </Box>
                    )}
                </Box>



                <Card sx={{ position: "relative", overflow: "hidden" }}>
                    <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
                        <Box
                            className="iframe-container"
                            ref={iframeContainerRef}
                            sx={{ 
                                width: "100%", 
                                height: "auto",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: { xs: "200px", sm: "300px" },
                                position: "relative",
                                overflow: "hidden"
                            }}
                        >
                            {shouldLoadAdIframe ? (
                                <iframe
                                    id="content-iframe"
                                    scrolling="no"
                                    loading="lazy"
                                    style={{
                                        border: "none",
                                        width: "100%",
                                        minHeight: "200px",
                                        display: "block"
                                    }}
                                ></iframe>
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    Laster annonse...
                                </Typography>
                            )}
                        </Box>
                    </CardContent>
                    <Box
                        sx={{
                            position: "absolute",
                            right: 16,
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    >
                        {/* <ArrowForwardIosIcon /> */}
                    </Box>
                </Card>

                <Box>
                    <Box display="flex" alignItems="center" mb={1}>
                        <Checkbox 
                            checked={deleteAccountChecked}
                            onChange={handleDeleteAccountCheck}
                        />
                        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>Jeg ønsker å slette min konto</Typography>
                    </Box>

                    <Box display="flex" alignItems="center">
                        <Checkbox
                            checked={
                                userDetails.info_toggle == 0 ? true : false
                            }
                            onChange={handleInfoToggleChange}
                            disabled={infoToggleLoading}
                            color="primary"
                        />
                        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}>
                            Ønsker ikke å motta informasjon
                            {infoToggleLoading && " (oppdaterer...)"}
                            {!infoToggleLoading && (
                                <span style={{ 
                                    marginLeft: '8px', 
                                    fontSize: '0.7rem', 
                                    color: userDetails.info_toggle == 0 ? '#d32f2f' : '#2e7d32' 
                                }}>
                                    {/* {userDetails.info_toggle == 0 ? '(Deaktivert)' : '(Aktivert)'} */}
                                </span>
                            )}
                        </Typography>
                    </Box>
                </Box>
            </Container>
            <Footer company_id={currentCompanyId || Cookies.get("company_id")} />
            
            {/* Delete Account Confirmation Modal */}
            <Modal 
                open={deleteConfirmationOpen} 
                onClose={handleDeleteCancel}
                aria-labelledby="delete-account-modal"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '90%', sm: 400 },
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography id="delete-account-modal" variant="h6" component="h2" sx={{ mb: 2, fontWeight: 'bold', color: 'error.main' }}>
                        🗑️ Bekreft sletting av konto
                    </Typography>
                    
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
                        Er du sikker på at du vil slette din konto? Denne handlingen kan ikke angres.
                        <br /><br />
                        <strong>Dette vil:</strong>
                        <br />• Slette alle dine kuponger og poeng
                        <br />• Fjerne deg fra denne bedriftens system
                        <br />• Logge deg ut umiddelbart
                    </Typography>
                    
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                        <Button
                            variant="outlined"
                            onClick={handleDeleteCancel}
                            disabled={deleteLoading}
                            sx={{ minWidth: 100 }}
                        >
                            Avbryt
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleDeleteConfirmation}
                            disabled={deleteLoading}
                            sx={{ minWidth: 100 }}
                        >
                            {deleteLoading ? 'Sletter...' : 'Slett konto'}
                        </Button>
                    </Box>
                </Box>
            </Modal>
            
          
            <Modal 
                open={modalOpen} 
                onClose={() => setModalOpen(false)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 2
                }}
            >
                <Box
                    sx={{
                        p: { xs: 2, sm: 4 },
                        background: "#fff",
                        maxWidth: { xs: "90%", sm: 400 },
                        width: "100%",
                        borderRadius: 2,
                        maxHeight: "90vh",
                        overflow: "auto",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
                    }}
                >
                    {selectedCoupon && (
                        <>
                            <Typography variant="h6" sx={{ 
                                fontSize: { xs: "1rem", sm: "1.25rem" },
                                mb: 1
                            }}>
                                {selectedCoupon.name}
                            </Typography>
                            <Typography sx={{ 
                                fontSize: { xs: "0.85rem", sm: "1rem" },
                                mb: 1
                            }}>
                                {selectedCoupon.description}
                            </Typography>
                            <Typography sx={{ 
                                fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                mt: 1
                            }}>
                                {/* Status: {selectedCoupon.status} */}
                                Vil du bruke denne kupongen nå?
                            </Typography>

                            {selectedCoupon.used === 1 ? (
                                <Typography color="error" sx={{ 
                                    mt: 2,
                                    fontSize: { xs: "0.8rem", sm: "0.9rem" }
                                }}>
                                    Denne kupongen er allerede brukt.
                                </Typography>
                            ) : new Date(selectedCoupon.end_date) <
                              new Date() ? (
                                <Typography color="error" sx={{ 
                                    mt: 2,
                                    fontSize: { xs: "0.8rem", sm: "0.9rem" }
                                }}>
                                   Denne kupongen er utløpt.
                                </Typography>
                            ) : (
                                <Box
                                    mt={2}
                                    display="flex"
                                    flexDirection={{ xs: "column", sm: "row" }}
                                    gap={{ xs: 1, sm: 2 }}
                                    justifyContent="space-between"
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            handleUseCoupon(selectedCoupon.id)
                                        }
                                        fullWidth={{ xs: true, sm: false }}
                                        disabled={useCouponLoading}
                                        startIcon={useCouponLoading ? <CircularProgress size={20} color="inherit" /> : null}
                                    >
                                        {useCouponLoading ? "Bruker..." : "Bruk kupong"}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setModalOpen(false)}
                                        fullWidth={{ xs: true, sm: false }}
                                    >
                                        Avbryt
                                    </Button>
                                </Box>
                            )}
                        </>
                    )}
                </Box>
            </Modal>

            {/* Welcome Modal for First-Time Users */}
            <Modal
                open={welcomeModalOpen}
                onClose={() => setWelcomeModalOpen(false)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: { xs: 2, sm: 0 },
                }}
            >
                <Fade in={welcomeModalOpen}>
                    <Box sx={{
                        bgcolor: 'background.paper',
                        borderRadius: { xs: 3, sm: 4 },
                        width: '100%',
                        maxWidth: { xs: '100%', sm: 550 },
                        maxHeight: '90vh',
                        overflow: 'auto',
                        outline: 'none',
                        position: 'relative',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                        bgcolor: 'background.paper',
                    }}>
                        {/* Close Button */}
                        <IconButton
                            onClick={() => setWelcomeModalOpen(false)}
                            sx={{
                                position: 'absolute',
                                right: { xs: 8, sm: 16 },
                                top: { xs: 8, sm: 16 },
                                zIndex: 1,
                                bgcolor: 'rgba(0,0,0,0.05)',
                                '&:hover': {
                                    bgcolor: 'rgba(0,0,0,0.1)',
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {/* Header with Celebration Icon */}
                        {/* <Box sx={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            p: { xs: 4, sm: 5 },
                            textAlign: 'center',
                            position: 'relative',
                            borderRadius: { xs: '12px 12px 0 0', sm: '16px 16px 0 0' },
                        }}>
                            <Box sx={{
                                width: { xs: 80, sm: 100 },
                                height: { xs: 80, sm: 100 },
                                borderRadius: '50%',
                                bgcolor: 'rgba(255,255,255,0.2)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 2,
                                animation: 'pulse 2s ease-in-out infinite',
                                '@keyframes pulse': {
                                    '0%, 100%': {
                                        transform: 'scale(1)',
                                    },
                                    '50%': {
                                        transform: 'scale(1.05)',
                                    },
                                },
                            }}>
                                <CelebrationIcon sx={{ 
                                    fontSize: { xs: 48, sm: 64 }, 
                                    color: 'white' 
                                }} />
                            </Box>
                            <Typography 
                                variant="h4" 
                                sx={{ 
                                    fontWeight: 700, 
                                    color: 'white',
                                    fontSize: { xs: '1.75rem', sm: '2rem' },
                                    mb: 1,
                                }}
                            >
                                Velkommen!
                            </Typography>
                            <Typography 
                                variant="body1" 
                                sx={{ 
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: { xs: '0.938rem', sm: '1rem' },
                                }}
                            >
                                Du har nå tilgang til kuponger og poeng
                            </Typography>
                        </Box> */}

                        {/* Content */}
                        <Box sx={{ p: { xs: 3, sm: 4 } }}>
                            <Typography 
                                variant="h6" 
                                sx={{ 
                                    mb: 3, 
                                    fontWeight: 600, 
                                    color: 'text.primary',
                                    fontSize: { xs: '1.125rem', sm: '1.25rem' },
                                    textAlign: 'center',
                                }}
                            >
                                Her er hva du kan gjøre:
                            </Typography>

                            {/* Features List */}
                            <Box sx={{ mb: 3 }}>
                                {/* Coupons Feature */}
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'flex-start', 
                                    mb: 3,
                                    p: 2,
                                    borderRadius: 2,
                                    bgcolor: 'grey.50',
                                }}>
                                    <Box sx={{
                                        width: { xs: 48, sm: 56 },
                                        height: { xs: 48, sm: 56 },
                                        borderRadius: '50%',
                                        bgcolor: 'primary.main',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        flexShrink: 0,
                                    }}>
                                        <CouponIcon sx={{ 
                                            fontSize: { xs: 28, sm: 32 }, 
                                            color: 'white' 
                                        }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography 
                                            variant="subtitle1" 
                                            sx={{ 
                                                fontWeight: 600, 
                                                mb: 0.5,
                                                color: 'text.primary',
                                                fontSize: { xs: '1rem', sm: '1.063rem' },
                                            }}
                                        >
                                            Se og bruk kuponger
                                        </Typography>
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: 'text.secondary',
                                                fontSize: { xs: '0.875rem', sm: '0.938rem' },
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            Utforsk tilgjengelige kuponger og bruk dem når du handler
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Points Feature */}
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'flex-start', 
                                    mb: 3,
                                    p: 2,
                                    borderRadius: 2,
                                    bgcolor: 'grey.50',
                                }}>
                                    <Box sx={{
                                        width: { xs: 48, sm: 56 },
                                        height: { xs: 48, sm: 56 },
                                        borderRadius: '50%',
                                        bgcolor: 'primary.main',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        flexShrink: 0,
                                    }}>
                                        <PointsIcon sx={{ 
                                            fontSize: { xs: 28, sm: 32 }, 
                                            color: 'white' 
                                        }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography 
                                            variant="subtitle1" 
                                            sx={{ 
                                                fontWeight: 600, 
                                                mb: 0.5,
                                                color: 'text.primary',
                                                fontSize: { xs: '1rem', sm: '1.063rem' },
                                            }}
                                        >
                                            Samle poeng
                                        </Typography>
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: 'text.secondary',
                                                fontSize: { xs: '0.875rem', sm: '0.938rem' },
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            Tjen poeng ved å bruke kuponger og løs dem inn for belønninger
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Check Feature */}
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'flex-start',
                                    p: 2,
                                    borderRadius: 2,
                                    bgcolor: 'grey.50',
                                }}>
                                    <Box sx={{
                                        width: { xs: 48, sm: 56 },
                                        height: { xs: 48, sm: 56 },
                                        borderRadius: '50%',
                                        bgcolor: 'primary.main',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        flexShrink: 0,
                                    }}>
                                        <CheckCircleIcon sx={{ 
                                            fontSize: { xs: 28, sm: 32 }, 
                                            color: 'white' 
                                        }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography 
                                            variant="subtitle1" 
                                            sx={{ 
                                                fontWeight: 600, 
                                                mb: 0.5,
                                                color: 'text.primary',
                                                fontSize: { xs: '1rem', sm: '1.063rem' },
                                            }}
                                        >
                                            Alt er klart!
                                        </Typography>
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: 'text.secondary',
                                                fontSize: { xs: '0.875rem', sm: '0.938rem' },
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            Du kan nå begynne å utforske alle funksjonene
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            {/* Action Button */}
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => setWelcomeModalOpen(false)}
                                sx={{
                                    py: { xs: 1.5, sm: 1.75 },
                                    borderRadius: 2,
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    fontSize: { xs: '1rem', sm: '1.063rem' },
                                }}
                            >
                                Kom i gang
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>

            {/* Alert Modal */}
            <Modal
                open={alertModalOpen}
                onClose={() => setAlertModalOpen(false)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box sx={{
                    bgcolor: 'background.paper',
                    p: 4,
                    borderRadius: 3,
                    width: '90%',
                    maxWidth: 400,
                    outline: 'none',
                    textAlign: 'center',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
                }}>
                    <Box sx={{
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        bgcolor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 2
                    }}>
                        <Typography sx={{ color: 'white', fontSize: '1.5rem' }}>
                            ℹ️
                        </Typography>
                    </Box>
                    
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                        Informasjon
                    </Typography>
                    
                    <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', lineHeight: 1.6 }}>
                        {alertMessage}
                    </Typography>
                    
                    <Button
                        variant="contained"
                        onClick={() => setAlertModalOpen(false)}
                        sx={{
                            px: 4,
                            py: 1.5,
                            borderRadius: 2,
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: '1rem'
                        }}
                    >
                        OK
                    </Button>
                </Box>
            </Modal>
        </>
    );
};

export default Index;
